import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Platform, View } from "react-native";
import { styledRN } from "../styled";
export const LoadingSpinner = Platform.OS === "web" ? require("./loading-spinner.web").LoadingSpinner : require("./loading-spinner.native").LoadingSpinner;
const LoadingSpinnerViewContainer = styledRN(View, {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
});
export const LoadingSpinnerView = React.memo(function LoadingSpinnerView() {
    return (_jsx(LoadingSpinnerViewContainer, { children: _jsx(LoadingSpinner, {}) }));
});
